import { render } from "./CosmoHome.vue?vue&type=template&id=24479560&scoped=true"
import script from "./CosmoHome.vue?vue&type=script&lang=js"
export * from "./CosmoHome.vue?vue&type=script&lang=js"

import "./CosmoHome.vue?vue&type=style&index=0&id=24479560&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24479560"]])

export default __exports__